<template>
  <el-form
    ref="ruleForm"
    :model="item"
    label-position="left"
    label-width="160px"
  >
    <el-form-item label="Material Mode">
      <el-radio-group v-model="item.material_type">
        <el-radio :label="CONSTANT.MATERIAL_TYPE.IMAGES">Images</el-radio>
        <el-radio :label="CONSTANT.MATERIAL_TYPE.HTML">Html</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item
      v-if="item.material_type === CONSTANT.MATERIAL_TYPE.IMAGES"
      label="Image"
      prop="image_url"
      :rules="[
        ...bannerImageRatioRule(limited_size.image),
        ...urlRule('image_url'),
      ]"
    >
      <file-input
        accept="image/jpeg, image/png, image/gif"
        v-model="item.image_url"
        :check_upload_image_ratio="{
          ...limited_size.image,
          enable: true,
        }"
      ></file-input>
    </el-form-item>
    <el-form-item
      v-if="item.material_type === CONSTANT.MATERIAL_TYPE.HTML"
      label="Html"
      prop="html_url"
      :rules="urlRule('html_url')"
    >
      <file-input
        accept="application/zip, application/x-zip-compressed, application/zip-compressed"
        v-model="item.html_url"
      ></file-input>
    </el-form-item>
    <el-form-item label="Size" prop="size" :rules="sizeRule('size')">
      <el-select
        v-model="item.size"
        filterable
        allow-create
        default-first-option
      >
        <el-option
          v-for="opt in sizeOption"
          :key="opt"
          :label="opt"
          :value="opt"
        ></el-option>
      </el-select>
    </el-form-item>
    <div v-show="item.material_type === CONSTANT.MATERIAL_TYPE.HTML">
      <el-form-item label="Html play time">
        <el-input-number
          v-model="item.millisecond"
          :step="1000"
          :min="0"
          :max="99000"
          :disabled="item.material_type === CONSTANT.MATERIAL_TYPE.IMAGES"
        ></el-input-number>
        <span> millisecond</span>
      </el-form-item>
      <el-form-item label="Loop">
        <el-switch v-model="item.loop">Loop Html play</el-switch>
      </el-form-item>
      <el-form-item label="Times">
        <el-input-number
          v-model="item.times"
          :step="1"
          :min="0"
          :max="9999"
          :disabled="
            item.material_type === CONSTANT.MATERIAL_TYPE.IMAGES ||
              item.loop === true
          "
        ></el-input-number>
      </el-form-item>
    </div>
    <video-item
      ref="video"
      replay
      v-if="withOutstream"
      :use-facebook-livestream="true"
    >
      <video-size
        :is-facebook-livestream="isFaceBookLiveStream"
        ref="videoSize"
        v-model="item.video"
        :max-width="width"
        :max-height="height"
      ></video-size>
    </video-item>
  </el-form>
</template>

<script>
import MixFormRule from '@/components/mixins/formRule';
import MixCreativeForm from '@/components/mixins/creativeForm';

export default {
  data() {
    return {
      item: {
        material_type: CONSTANT.MATERIAL_TYPE.IMAGES || 0,
        image_url: '',
        html_url: '',
        size: '300x250',
        millisecond: 0,
        loop: true,
        times: 0,
        video: {
          height: 0,
          width: 0,
          vertical: {
            align: 'center',
            padding: 0,
          },
          horizontal: {
            align: 'center',
            padding: 0,
          },
        },
      },
      withOutstream: _.includes(this.value._type, 'WithOutstream'),
      height: 250,
      width: 300,
      sizeOption: [
        '300x250',
        '336x280',
        '320x50',
        '728x90',
        '300x100',
        '320x100',
        '160x600',
        '300x600',
        '320x480',
        '610x100',
        '970x250',
        '960x100',
      ],
      isMounted: false,
    };
  },
  mounted() {
    this.isMounted = true;
  },
  computed: {
    isFaceBookLiveStream() {
      if (!this.isMounted) return;
      return this.$refs.video.item.type === 'facebook_video_url';
    },
    limited_size() {
      return {
        image: {
          width: {
            max: parseInt(this.item.size.split('x')[0]),
            min: parseInt(this.item.size.split('x')[0]),
          },
          height: {
            max: parseInt(this.item.size.split('x')[1]),
            min: parseInt(this.item.size.split('x')[1]),
          },
        },
      };
    },
  },
  mixins: [MixFormRule, MixCreativeForm],
  watch: {
    'item.size'(newVal) {
      const size = newVal.split('x');
      this.width = Number(size[0]);
      this.height = Number(size[1]);
    },
  },
  methods: {
    setData(row) {
      this.width = row.width;
      this.height = row.height;
      this.item.material_type = row.material_type;
      this.item.image_url = decodeURI(row.image_url);
      this.item.html_url = decodeURI(row.html_url || '');
      this.item.size = `${row.width}x${row.height}`;
      if (row.material_type === CONSTANT.MATERIAL_TYPE.HTML) {
        this.item.millisecond = row.millisecond;
        if (row.times === -1) {
          this.item.loop = true;
        } else {
          this.item.loop = false;
        }
        this.item.times = row.times;
      }
      if (this.withOutstream) {
        this.item.video.height = row.video_height;
        this.item.video.width = row.video_width;
        _.forEach(['vertical', 'horizontal'], (key) => {
          this.item.video[key].align = row[`${key}_align`];
          if (row[`${key}_align`] !== 'center') {
            this.item.video[key].padding = row[`${key}_padding`];
          }
        });
        this.$refs.video.setData(row);
      }
    },
    async getData(setObj) {
      setObj.material_type = this.item.material_type;
      setObj.image_url = this.item.image_url.replace(/[^\x00-\x7F]/g, (c) => encodeURI(c));
      setObj.html_url = this.item.html_url.replace(/[^\x00-\x7F]/g, (c) => encodeURI(c));
      setObj.width = this.width;
      setObj.height = this.height;
      if (this.item.material_type === CONSTANT.MATERIAL_TYPE.HTML) {
        setObj.millisecond = this.item.millisecond;
        if (this.item.loop) {
          setObj.times = -1;
        } else {
          setObj.times = this.item.times;
        }
      }
      if (this.withOutstream) {
        const video = this.item.video;
        setObj.video_height = video.height;
        setObj.video_width = video.width;
        _.forEach(['vertical', 'horizontal'], (key) => {
          setObj[`${key}_align`] = video[key].align;
          if (video[key].align !== 'center') {
            setObj[`${key}_padding`] = video[key].padding;
          }
        });
        setObj = await this.$refs.video.getData(
          setObj,
          setObj.video_width,
          setObj.video_height
        );
      }

      return setObj;
    },
  },
};
</script>

<style></style>
